<template>
  <div class="our aboutUs">
     <p class="our_common_title">公司简介</p>
     <img src="/static/images/m/aboutUs.jpg" alt="" class="banner">
     <div class="aboutUs_detail">
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">1</span><span>帝景</span></p>
         <div class="aboutUs_item_text">
           上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球典范品质的纯进口卫浴产品及一站式系统服务。
         </div>
       </div>
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">2</span><span>品牌</span></p>
         <div class="aboutUs_item_text">
          公司成立至今，已先后获得多个国际品牌的认可，目前代理品牌主要有意大利BISAZZA艺术马赛克、地板、卫浴，意大利FIR艺术水龙头、意大利WEBERT时尚水龙头，意大利DEVON&DEVON古典卫浴，德国HOESCH豪华按摩浴缸，美国CALDERA户外SPA等。
         </div>
       </div>
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">3</span><span>理念</span></p>
         <div class="aboutUs_item_text">
          我们不仅提供原装进口的卫浴建材产品，更以为客户创造健康、舒适、高品质的卫浴生活方式为我们的价值理念，公司已先后服务于众多私人豪宅客户和酒店会所项目，获得优良口碑。从过去、现在到未来，公司一直专注于卫浴这一领域，立志成为中国领衔的卫浴服务商，为更多中国用户创造健康卫浴生活！
         </div>
       </div>
     </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){

  }
}
</script>

<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}
.aboutUs_detail{
  padding: 0.6rem 0.2rem 0;
}
.aboutUs_item{
  margin-bottom: 0.5rem;
}
.aboutUs_item:last-child{
  margin-bottom: 0;
}
.item_tittle{
  height: 0.7rem;
  line-height: 0.7rem;
  padding-right: 0.26rem;
  padding-left: 0.1rem;
  background-color: #f8f7f7;
  display: inline-block;
  border-radius: 0.04rem;
  font-size: 0.24rem;
  color: #000000;
  margin-bottom: 0.4rem;
}
.item_tittle .num{
 width: 0.5rem;
 height: 0.5rem;
 color: #fff;
 font-weight: bold;
 text-align: center;
 line-height: 0.5rem;
 display: inline-block;
 background-color: #3478f7;
 border-radius: 0.04rem;
 margin-right: 0.24rem;
}
.aboutUs_item_text{
  font-size: 0.24rem;
  color: #000;
  line-height: 200%;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/about_us.vue